const sensitiveItems = [
    'coffee', 'wood', 'milk', 'vitamin', 'surgical', 'feather', 'fur', 'knife', 
    'ivory', 'meat', 'beef', 'chicken', 'pork', 'silver', 'gold', 'led'
];

export default sensitiveItems;